export default "__VITE_ASSET__jSwAcKtc__"